import { create } from "zustand";
import { persist } from "zustand/middleware";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL; // https://rvtk.edu.kz/api/

// Zustand store
const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      isAuthenticated: false,

      // Login
      login: async (username, password) => {
        try {
          const response = await axios.post(`${API_URL}login`, {
            username,
            password,
          });
          const { user, access_token } = response.data;

          // Сохраняем данные в Zustand
          set({
            user,
            accessToken: `Bearer ${access_token}`,
            isAuthenticated: true,
          });
          return true;
        } catch (error) {
          console.error("Login failed:", error);
          throw error;
        }
      },

      // Logout
      logout: () => {
        set({
          user: null,
          accessToken: null,
          isAuthenticated: false,
        });
      },

      // Register
      register: async (username, password, role_ids) => {
        try {
          await axios.post(
            `${API_URL}register`,
            { username, password, role_ids },
            {
              headers: {
                Authorization: get().accessToken,
              },
            },
          );
        } catch (error) {
          console.error("Registration failed:", error);
          throw error;
        }
      },

      // Update user
      updateUser: async (id, username, password, role_ids) => {
        try {
          await axios.post(
            `${API_URL}register`,
            { id, username, password, role_ids },
            {
              headers: {
                Authorization: get().accessToken,
              },
            },
          );
        } catch (error) {
          console.error("Updating user failed:", error);
          throw error;
        }
      },

      getUsers: async (id = 0) => {
        try {
          const params = id !== 0 ? { id } : {}; // Формируем параметры запроса
          const response = await axios.get(`${API_URL}users`, {
            params, // Параметры запроса
            headers: {
              Authorization: get().accessToken, // Передаем токен
            },
          });
          return response.data.users;
        } catch (error) {
          console.error("Get Users failed:", error);
          throw error;
        }
      },

      getRoles: async (id = 0) => {
        try {
          const params = id !== 0 ? { id } : {}; // Формируем параметры запроса
          const response = await axios.get(`${API_URL}roles`, {
            params, // Параметры запроса
            headers: {
              Authorization: get().accessToken, // Передаем токен
            },
          });
          return response.data.roles;
        } catch (error) {
          console.error("Get Roles failed:", error);
          throw error;
        }
      },
      getTeachers: async (id = 0, user_id = 0) => {
        try {
          const params = id !== 0 ? { id } : user_id !== 0 ? { user_id } : {}; // Формируем параметры запроса
          const response = await axios.get(`${API_URL}teachers`, {
            params, // Параметры запроса
            headers: {
              Authorization: get().accessToken, // Передаем токен
            },
          });
          return response.data;
        } catch (error) {
          console.error("Get Roles failed:", error);
          throw error;
        }
      },

      getGroups: async (id = 0) => {
        try {
          const params = id !== 0 ? { id } : {}; // Формируем параметры запроса
          const response = await axios.get(`${API_URL}groups`, {
            params, // Параметры запроса
            headers: {
              Authorization: get().accessToken, // Передаем токен
            },
          });
          return response.data.teachers;
        } catch (error) {
          console.error("Get Roles failed:", error);
          throw error;
        }
      },
      getSubjects: async (id = 0) => {
        try {
          const params = id !== 0 ? { id } : {}; // Формируем параметры запроса
          const response = await axios.get(`${API_URL}subjects`, {
            params, // Параметры запроса
            headers: {
              Authorization: get().accessToken, // Передаем токен
            },
          });
          return response.data.subjects;
        } catch (error) {
          console.error("Get Roles failed:", error);
          throw error;
        }
      },
      getStudents: async (id = 0) => {
        try {
          const params = id !== 0 ? { id } : {}; // Формируем параметры запроса
          const response = await axios.get(`${API_URL}students`, {
            params, // Параметры запроса
            headers: {
              Authorization: get().accessToken, // Передаем токен
            },
          });
          return response.data.students;
        } catch (error) {
          console.error("Get Roles failed:", error);
          throw error;
        }
      },
      getSchedules: async (id = 0) => {
        try {
          const params = id !== 0 ? { id } : {}; // Формируем параметры запроса
          const response = await axios.get(`${API_URL}schedules`, {
            params, // Параметры запроса
            headers: {
              Authorization: get().accessToken, // Передаем токен
            },
          });
          return response.data.schedules;
        } catch (error) {
          console.error("Get Roles failed:", error);
          throw error;
        }
      },
      getOffices: async (id = 0) => {
        try {
          const params = id !== 0 ? { id } : {}; // Формируем параметры запроса
          const response = await axios.get(`${API_URL}offices`, {
            params, // Параметры запроса
            headers: {
              Authorization: get().accessToken, // Передаем токен
            },
          });
          return response.data.offices;
        } catch (error) {
          console.error("Get Roles failed:", error);
          throw error;
        }
      },
      getNews: async (page = 1, limit = 3, year = null, month = null) => {
        try {
          const params = { page, limit };
          if (year) params.year = year;
          if (month) params.month = month;

          const response = await axios.get(`${API_URL}news`, {
            params,
            headers: {},
          });
          return response.data; // Now returns { news, total, pages, has_next, ... }
        } catch (error) {
          console.error("Get News failed:", error);
          throw error;
        }
      },
      getNewsById: async id => {
        try {
          const response = await axios.get(`${API_URL}news`, {
            params: { id },
            headers: {},
          });
          return response.data.news; // Returns single news object
        } catch (error) {
          console.error("Get News By ID failed:", error);
          throw error;
        }
      },
      getNewsDates: async () => {
        try {
          const response = await axios.get(`${API_URL}news/dates`);
          return response.data.dates;
        } catch (error) {
          console.error("Get News Dates failed:", error);
          throw error;
        }
      },
      createNews: async newsData => {
        try {
          const response = await axios.post(
            `${API_URL}news`, // URL (POST /news)
            newsData, // Данные (Flask ожидает их в request.json)
            {
              // Конфигурация (включая заголовки)
              headers: {
                Authorization: get().accessToken,
              },
            },
          );
          return response.data; // Вернет {'msg': 'Новость добавлена'}
        } catch (error) {
          console.error("Create News failed:", error);
          throw error;
        }
      },

      updateNews: async newsData => {
        try {
          // Твой Flask API ожидает PUT на тот же URL /news
          // и ищет ID внутри JSON-тела (request.json.get("id"))
          const response = await axios.put(
            `${API_URL}news`, // URL (PUT /news)
            newsData, // Данные (включая ID)
            {
              headers: {
                Authorization: get().accessToken,
              },
            },
          );
          return response.data; // Вернет {'msg': 'Новость обновлена'}
        } catch (error) {
          console.error("Update News failed:", error);
          throw error;
        }
      },

      deleteNewsApi: async newsId => {
        try {
          // ВАЖНО: Твой Flask API ожидает DELETE-запрос на /news,
          // а сам ID он ожидает ВНУТРИ ТЕЛА JSON (request.json.get("id")).
          // Axios.delete() отправляет тело запроса в ключе 'data' внутри конфига.
          const response = await axios.delete(
            `${API_URL}news`, // URL (DELETE /news)
            {
              headers: {
                Authorization: get().accessToken,
              },
              data: {
                id: newsId, // Вот тело, которое ожидает Flask
              },
            },
          );
          return response.data; // Вернет {'msg': 'Новость удалена'}
        } catch (error) {
          console.error("Delete News failed:", error);
          throw error;
        }
      },
      uploadPdf: async pdfFile => {
        if (!get().isAuthenticated) {
          throw new Error("Не авторизован для загрузки PDF");
        }

        try {
          const formData = new FormData();
          // 'file' — это имя, которое ожидает ваш Flask-бэкенд
          formData.append("file", pdfFile);

          const response = await axios.post(
            `${API_URL}ai/upload_pdf`, // Маршрут для загрузки PDF
            formData,
            {
              headers: {
                // Обязательно для файлов
                "Content-Type": "multipart/form-data",
                // Обязательно для защиты
                Authorization: get().accessToken,
              },
            },
          );

          console.log("PDF Upload success:", response.data);
          return response.data; // { success: true, message: '...' }
        } catch (error) {
          console.error("PDF Upload failed:", error);
          throw error;
        }
      },
    }),
    {
      name: "auth-storage", // Key для сохранения в localStorage
      partialize: state => ({
        user: state.user,
        accessToken: state.accessToken,
        isAuthenticated: state.isAuthenticated,
      }), // Сохраняем только нужные данные
    },
  ),
);

export default useAuthStore;
